// LocalStorage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
};

export const URI = {
  API: process.env.REACT_APP_LOCAL_API_URI || "https://api-dev.asso-rail.ru",
};
